<template>
  <el-dialog
    title="进度详情"
    width="30%"
    :visible.sync="visible"
    :show-close="false"
    :destroy-on-close="true"
    center
  >
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in timeline"
        :key="index"
        :timestamp="item.created_at"
      >
        {{ item.post_status_name }}
      </el-timeline-item>
    </el-timeline>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="close()" size="medium">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BaseDialog from "../BaseDialog";

export default {
  name: "ProcessDialog",
  extends: BaseDialog,
  data() {
    return {
      timeline: [],
    };
  },
  mounted() {},
  methods: {
    open(item) {
      this.visible = true;
      this.timeline = item.timeline;
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin: 0 auto;
  width: 80%;
}
</style>